(function () {
  /* Mark country confirmed when any localization form submits (drawer, header, footer, etc.)
     so the shipping-location-popup won't reappear after a manual country switch. */
  document.addEventListener('submit', function (e) {
    if (!e.target.querySelector('input[name="country_code"]')) return;
    if (e.target.closest('#shipping-location-popup')) return;
    try { sessionStorage.setItem('shipping_location_confirmed', '1'); } catch (err) {}
  });

  var drawer = document.getElementById('CountryDrawer');
  if (!drawer) return;

  var select = document.getElementById('CountryDrawerSelect');
  var hiddenInput = drawer.querySelector('input[name="country_code"]');

  var scrollY = 0;

  function open() {
    scrollY = window.scrollY;
    drawer.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '-' + scrollY + 'px';
  }

  function close() {
    drawer.classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  document.querySelectorAll('[data-country-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });

  drawer.querySelectorAll('[data-country-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  drawer.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') close();
  });

  var subtitle = drawer.querySelector('.country-drawer--subtitle');

  var form = drawer.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.country-drawer--button');
      if (btn) btn.classList.add('is-loading');
    });
  }

  if (select && hiddenInput) {
    select.addEventListener('change', function () {
      hiddenInput.value = this.value;
      var selected = this.options[this.selectedIndex];
      if (subtitle && selected) {
        subtitle.innerHTML = 'You are currently shipping to <strong>' + selected.dataset.name + '</strong> and will be billed in <strong>' + selected.dataset.currency + '</strong>';
      }
    });
  }
})();
